import { US_STATES } from '@/lib/usStates'
import { SimpleSelect } from './select-with-more'

// A select item can't carry an empty value, so "---" stands in for one and is read back as ''.
const NO_STATE = '__none__'

export const StateSelect = ({
  error,
  value,
  onChange,
  clearable,
  id,
}: {
  error: boolean
  value: string
  onChange: (value: string) => void
  /** Leads the list with "---", which empties the field, for fields where the state is optional. */
  clearable?: boolean
  id?: string
}) => {
  const states = US_STATES.map(([code]) => ({ value: code, label: code }))

  return (
    <SimpleSelect
      id={id}
      options={clearable ? [{ value: NO_STATE, label: '---' }, ...states] : states}
      value={value}
      onValueChange={(next) => onChange(next === NO_STATE ? '' : next)}
      error={error}
      placeholder="Select state..."
      className="w-full max-w-48"
    />
  )
}
